/* ============================================================
   Announcement bar — seamless continuous marquee loop
   ============================================================ */
(function () {
  if (window.__annMarqueeInit) return;
  window.__annMarqueeInit = true;

  function initMarquee() {
    document.querySelectorAll('.hlp-ann__track:not([data-hlp-dup])').forEach(function (track) {
      track.setAttribute('data-hlp-dup', '1');
      var original = track.innerHTML;
      var vp = (track.parentElement && track.parentElement.offsetWidth) || window.innerWidth || 1000;
      var guard = 0;
      while (track.scrollWidth < vp + 300 && guard < 40) {
        track.innerHTML += original;
        guard++;
      }
      track.innerHTML += track.innerHTML;
      track.style.animationDuration = Math.max(14, (track.scrollWidth / 2) / 70) + 's';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }
})();
